import script from "./PrivacyPolicyEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyPolicyEdit.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyPolicyEdit.vue?vue&type=style&index=0&id=7cb5c6c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cb5c6c6"]])

export default __exports__